import { useEffect } from "react"
import PremiumStore from "../../stores/PremiumStore"
export const StripePaywallPre = () => {
    useEffect(()=>{
        PremiumStore.createStripeSessionPre()
    }, [])
    return (<div></div>)
}